export default __webpack_public_path__ + "5a95e8abc3b5df98fb61b70541f9ab59.svg";